<script setup lang="ts"></script>

<template>
  <HeroBase
    class="xl:pb-36"
    title="Cara Cerdas Kirim Paket Untuk Bisnis Anda"
    sub-title="Satu Platform, Banyak Ekspedisi – Kirim Cepat, Pantau Mudah"
    description="Nikmati pengalaman kirim paket yang lebih mudah dan menyenangkan dengan berbagai fitur unggulan."
  >
    <template #action>
      <div class="flex items-center gap-2 lg:gap-4">
        <UiButton
          :to="$utm.utmUrl('https://app.kiriminaja.com/register')"
          label="Daftar Gratis"
        />
        <div class="flex items-center gap-3 lg:gap-4">
          <div class="flex">
            <UiAvatarBase
              class="shadow border border-outline-variant w-7 h-7 lg:w-8 lg:h-8 text-primary bg-secondary-container -mr-2"
              image="/images/home-v4/user-1.webp"
              fallback-name="N"
            />
            <UiAvatarBase
              class="shadow border border-outline-variant w-7 h-7 lg:w-8 lg:h-8 text-primary bg-secondary-container -mr-2"
              image="/images/home-v4/user-2.webp"
              fallback-name="B"
            />
            <UiAvatarBase
              class="shadow border border-outline-variant w-7 h-7 lg:w-8 lg:h-8 text-primary bg-secondary-container -mr-2"
              image="/images/home-v4/user-3.webp"
              fallback-name="P"
            />
          </div>
          <div class="space-y-0">
            <p class="text-xxs lg:text-xs">Dipercaya</p>
            <p class="text-xxs lg:text-xs font-bold">+200rb Customer</p>
          </div>
        </div>
      </div>
    </template>
  </HeroBase>
</template>
